import { call, fork, put, takeEvery } from 'redux-saga/effects';
import balanceActions from './actions';
import { excelDownLoad, setRequestForm, setResponseListForm } from '../../../lib/common';
import toastMsg from '../../../lib/toastMsg';
import BalanceToastMsg from '../../../constants/service/toastMsg/balanceToastMsg';
import { BALANCE_STATUS_TEXT } from '../../../constants/service/app/balanceConstants';
import BalanceApi from '../../../lib/api/balance/BalanceApi';

function* fetchList() {
  /**
   *  [정산 리스트] 정산 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(balanceActions.GET_BALANCE_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(BalanceApi.getBalanceListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(BalanceToastMsg.GET_BALANCE_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad(BALANCE_STATUS_TEXT[payload.balanceStatus], result.data.balanceListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || BalanceToastMsg.GET_BALANCE_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   * [정산 리스트] 정산 아이템 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(balanceActions.GET_BALANCE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(BalanceApi.getBalanceItemListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(BalanceToastMsg.GET_BALANCE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad('정산 아이템 리스트', result.data.balanceItemListExcelSheet);
    } catch (error) {
      toastMsg.error(error.message || BalanceToastMsg.GET_BALANCE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [정산 상세] 정산 상세 요청하기
   */
  yield takeEvery(balanceActions.GET_BALANCE_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(BalanceApi.getBalanceDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(BalanceToastMsg.GET_BALANCE_DETAIL_REQUEST_SUCCESS);

        const data = {
          balanceDetail: result.data.balanceDetail,
        };

        yield put({ type: balanceActions.GET_BALANCE_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(BalanceToastMsg.GET_BALANCE_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [정산 상세] 정산 상세 업데이트하기
   */
  yield takeEvery(balanceActions.EDIT_BALANCE_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(BalanceApi.editBalanceDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(BalanceToastMsg.EDIT_BALANCE_DETAIL_REQUEST_SUCCESS);

        yield put(
          balanceActions.getBalanceDetail({
            balanceId: payload.balanceId,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(BalanceToastMsg.EDIT_BALANCE_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [정산 브랜드 리스트] 정산 브랜드 리스트 요청하기
   */
  yield takeEvery(balanceActions.GET_BALANCE_BRAND_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(BalanceApi.getBalanceBrandList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(BalanceToastMsg.GET_BALANCE_BRAND_LIST_REQUEST_SUCCESS);

        const data = {
          balanceBrandList: setResponseListForm(result.data.balanceBrandList, result.data.totalCnt, payload),
        };

        yield put({ type: balanceActions.GET_BALANCE_BRAND_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(BalanceToastMsg.GET_BALANCE_BRAND_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [정산 브랜드 리스트] 정산 브랜드 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(balanceActions.GET_BALANCE_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(BalanceApi.getBalanceBrandListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(BalanceToastMsg.GET_BALANCE_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('브랜드별 정산 타입 리스트', result.data.balanceBrandListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || BalanceToastMsg.GET_BALANCE_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });
}

export default function* balanceSaga() {
  yield fork(fetchList);
}
